"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = x => () => x;

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/victory-vendor/lib-vendor/d3-interpolate/src/constant.js
// module id = ./node_modules/victory-vendor/lib-vendor/d3-interpolate/src/constant.js
// module chunks = 1